import { render, staticRenderFns } from "./EmployeeWarning.vue?vue&type=template&id=78804178&"
import script from "./EmployeeWarning.vue?vue&type=script&lang=js&"
export * from "./EmployeeWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports